import { useCurrency } from "@shared/selectors/globalSelectors";
import { Card, CardContent } from "@shared/ui/card";

interface MonthlyTrend {
  month: string;
  consumption: string;
  cost: string;
}

export const MonthlyEnergyTrends = ({ data }: any) => {
  const currency = useCurrency();
  const monthlyTrends = data?.monthlyTrends?.items ?? [];

  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-2xl font-bold">Monthly Energy Trends</h2>
        <p className="text-muted-foreground">Last 6 months</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
        {monthlyTrends.map((trend, index) => (
          <Card
            key={index}
            className="group bg-white border hover:shadow-lg transition-all duration-300 rounded-xl"
          >
            <CardContent className="p-5 flex flex-col items-center text-center space-y-4">
              {/* Month heading badge */}
              <div className="px-3 py-1 rounded-full bg-blue-50 text-blue-600 font-semibold text-sm">
                {trend.month}
              </div>

              {/* Consumption metric */}
              <div className="space-y-1">
                <p className="text-xs font-medium text-muted-foreground tracking-wide">
                  Consumption
                </p>
                <p className="text-4xl font-extrabold text-blue-600 leading-tight">
                  {trend.consumptionMwh}
                  <span className="text-sm ml-1 font-medium text-muted-foreground">
                    MWh
                  </span>
                </p>
              </div>

              {/* Divider */}
              <div className="h-[1px] w-2/3 bg-gray-200" />

              {/* Cost metric */}
              <div className="space-y-1">
                <p className="text-xs font-medium text-muted-foreground tracking-wide">
                  Cost
                </p>
                <p className="text-2xl font-bold text-green-600">
                  {currency} {trend.cost}
                </p>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};
